<template>
  <div class="typeahead-dialog">
    <md-input
      :disabled="disabled || null"
      :debounce="0"
      @focus="handleFocus"
      class="typeahead-dialog__input-trigger"
      data-hj-allow
      id="autocomplete-input-mobile"
    >
    </md-input>

    <div class="typeahead-dialog__input-container" :class="inputContainerClasses" ref="inputDialog">
      <md-whiteframe class="typeahead-dialog__search-actions">
        <md-button @click="closeInputContainer" class="md-icon-button typeahead-dialog__search-actions-close">
          <md-icon :mdSvg="mdiArrowLeft" />
        </md-button>
        <div class="typeahead-dialog__search-actions-input">
          <md-input-container class="typeahead-dialog__search-actions-input-container--embed">
            <md-chip
              v-for="selected in selectedItems"
              md-deletable
              class="typeahead-dialog__input-container-chip"
              @delete="deleteSelected(selected)"
              :key="getId(selected)"
            >
              <slot name="mobileChip" :value="selected"></slot>
            </md-chip>
            <div class="typeahead-dialog__input-container-box">
              <md-input
                v-model="query"
                :debounce="0"
                @focus="onSearchInputFocus"
                @blur="onSearchInputBlur"
                @keydown.native="charHandler"
                @textInput.native="textInputHandler"
                @keydown.prevent.enter="
                  () => {
                    if (onlyChips) {
                      createItem();
                    }
                  }
                "
                data-hj-allow
                placeholder="Find"
                ref="searchInput"
              >
              </md-input>
              <md-icon v-if="query.length === 0" class="typeahead-dialog__search-hint" :mdSvg="mdiMagnify" />
              <md-button v-else class="md-icon-button md-dense" @click="handleClearSearch">
                <md-icon :mdSvg="mdiClose" />
              </md-button>
            </div>
          </md-input-container>
        </div>
      </md-whiteframe>
      <md-progress v-if="loading" md-indeterminate key="stateLoading"></md-progress>
      <div v-else key="stateLoaded" class="typeahead-dialog__results" ref="results">
        <md-list ref="list">
          <md-list-item
            v-if="(addNewItem && query.length > 0 && !queryInItemList) || (softList && query.length < minChars)"
            @click="createItem"
          >
            <slot name="mobileCreate" :query="query" :queryInItemExcludedList="queryInItemExcludedList"></slot>
          </md-list-item>
          <template v-if="grouped">
            <template v-for="item in itemList" :key="item.title">
              <md-list-item>
                <span class="title">{{ item.title }}</span>
              </md-list-item>
              <md-list-item
                v-for="value in filterSelectedItems(item.values)"
                @click="selectItem(value)"
                :key="getId(value)"
              >
                <slot name="mobileItem" :item="value" :formatted="formatText(value)"></slot>
              </md-list-item>
              <md-list-item v-if="emptyValuesMessage && !filterSelectedItems(item.values)?.length">
                <span class="empty-state">{{ emptyValuesMessage }}</span>
              </md-list-item>
            </template>
          </template>
          <md-list-item v-else v-for="item in unselectedItems" :key="getId(item)" @click="selectItem(item)">
            <slot name="mobileItem" :item="item" :formatted="formatText(item)"></slot>
          </md-list-item>
        </md-list>
      </div>
    </div>
  </div>
</template>

<script src="./tdlTypeaheadDialog.mjs"></script>
<style src="./tdlTypeaheadDialog.scss" lang="scss"></style>
